const withdrawalGetter = (state) => state.wallet.withdrawal;

export const withdrawalSelector = (state) => ({
  withdrawal: withdrawalGetter(state)
});
